import cx from 'classnames'
import { MdDeleteOutline } from 'react-icons/md'

import styles from '../actionIcons.module.scss'

export function Trash ({ onClick, type, disabled }) {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={cx(styles.actionIcon, styles.trash)}
      data-role='trash-icon'
      title={`Delete ${type}`}
    >
      <MdDeleteOutline size='1.4rem' />
    </button>
  )
}
